export enum HttpPatchOperation {
  Replace = 'replace',
  Add = 'add',
  Remove = 'remove'
}
